import React from "react";
import Service from "../../../Pages/Service";
const ServicesPage = () => {
  return <Service/>;
};

export default ServicesPage;
